/**
 * Shared duration formatters. Centralised so the 5 dashboard panels that
 * surface durations (overview-cards, workflows-table, slowest-jobs, the two
 * trend charts) stay visually consistent.
 *
 * `formatMs` returns a compact human-readable string:
 *   0 or less      → "0s"
 *   < 60s          → "Xs"
 *   < 60m          → "Xm Ys"   (omits "Ys" when 0)
 *   ≥ 60m          → "Xh Ym"   (omits "Ym" when 0)
 *
 * Callers that prefer a dash for "no data" (instead of "0s") can check the
 * raw ms before delegating.
 */
export function formatMs(ms: number): string {
  if (ms <= 0) return "0s";
  const s = Math.round(ms / 1000);
  if (s < 60) return `${s}s`;
  const totalMinutes = Math.floor(s / 60);
  const remSec = s % 60;
  if (totalMinutes < 60) return remSec === 0 ? `${totalMinutes}m` : `${totalMinutes}m ${remSec}s`;
  const h = Math.floor(totalMinutes / 60);
  const remMin = totalMinutes % 60;
  return remMin === 0 ? `${h}h` : `${h}h ${remMin}m`;
}

/** Formats an integer count of minutes as `"Xh Ym"` or `"Xm"` when < 60. */
export function formatMinutes(min: number): string {
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  const rem = min % 60;
  return rem === 0 ? `${h}h` : `${h}h ${rem}m`;
}
